<template>
  <div id="app" style="width:100%;height:100%;overflow:hidden">
<!--    <img src="./assets/logo.png">-->
<!--    <Header />-->
    <router-view ref="shopHome"/>
<!--    <Footer />-->
  </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
export default {
  name: 'App',
  // components: {
  //   Header,
  //   Footer
  // },
  data() {
    return {
      searchShopText: '',//Header页面的搜索框的搜索内容
    }
  },
  methods: {
    // handleSearch(text) {
    //   console.log('父组件接收:', text)
    //   // 可以在这里处理或直接传递给 ShopHome
    //   if (this.$refs.shopHome && this.$refs.shopHome.handleSearch) {
    //     this.$refs.shopHome.handleSearch(text);
    //   }
    // }
  }
}
</script>

<style>
/* 全局样式 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Arial', sans-serif;
  line-height: 1.6;
}

/*#app {*/
/*  display: flex;*/
/*  flex-direction: column;*/
/*  min-height: 100vh;*/
/*}*/

.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue